import { Request } from "../../request";
import { getURL } from "../../utils";

export const get_company_employee = () => {
  return new Promise((resolve) => {
    resolve({
      code: 200,
      success: true,
      message: "",
      pagination: {
        count: 4,
        pages: 1,
        page: 1,
        limit: 10,
        next: null,
        next_url: null,
        previous: null,
        previous_url: null,
      },
      data: [
        {
          provinces: [{ name: "اصفهان", id: 9 }],
          cities: [{ name: "اصفهان", id: 9 }],
          user: {
            fullname: "حسام زندیان",
            national_id: "1234567890",
            phone_number: "09876543210",
          },
          post: "سرپرست",
          created_at: "1401-10-11",
        },
      ],
      extra: {},
      meta: {
        site: "helix",
        site_id: 4,
        version: "1.3.8\n",
        app_version: "0.0.0",
      },
    });
  });
};

export const set_company_employee = (data) => {
  return Request.post(getURL(`/api/corporation-pa/accounts/set-company-employee/`), data);
};

export const set_company_employee_cities = (data) => {
  return Request.post(
    getURL(`/api/corporation-pa/accounts/set-company-employee-cities/`),
    data
  );
};

export const get_company_employee_car = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        code: 200,
        success: true,
        message: "",
        pagination: {
          count: 4,
          pages: 1,
          page: 1,
          limit: 10,
          next: null,
          next_url: null,
          previous: null,
          previous_url: null,
        },
        data: [
          {
            id: 6,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1385",
            plate_number: "585ع74 ایران 43",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 5,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1385",
            plate_number: "442ع74 ایران 43",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1385",
            plate_number: "577ع74 ایران 43",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 3,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NKR",
              is_jalali: false,
            },
            year: "1395",
            plate_number: "559ع73 ایران 55",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1395",
            plate_number: "541ع73 ایران 55",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1393",
            plate_number: "992ع56 ایران 44",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1396",
            plate_number: "192و75 ایران 22",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "715م99 ایران 22",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "385م91 ایران 22",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "385م91 ایران 22",
            city: "اصفهان",
            province: "اصفهان",
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "385م91 ایران 22",
            city: "اصفهان",
            province: "اصفهان",
          },
        ],
        extra: {},
        meta: {
          site: "helix",
          site_id: 4,
          version: "1.3.8\n",
          app_version: "0.0.0",
        },
      });
    }, 2000);
  });
};

export const set_company_employee_car = (company_driver_id, car_id) => {
  return Request.post(getURL(`/api/corporation-pa/accounts/set-company-driver-car/`), {
    company_driver_id,
    car_id,
  });
};

export const put_company_employee = (data) => {
  return Request.put(getURL(`/api/corporation-pa/accounts/set-company-employee/`), data);
};

const provinces = [
  {
    id: 3,
    name: "تهران",
  },
  {
    id: 4,
    name: "اصفهان",
  },
  {
    id: 8,
    name: "البرز",
  },
  {
    id: 23,
    name: "خراسان رضوی",
  },
];

export const get_provinces = () => {
  return new Promise((resolve) => {
    resolve({
      data: provinces,
      status: "200",
      message: "",
      success: true,
    });
  });
};

const city_data = [
  {
    id: 3,
    data: [
      {
        id: 8,
        name: "تهران",
      },
      {
        id: 210,
        name: "شهریار",
      },
    ],
  },
  {
    id: 4,
    data: [
      {
        id: 9,
        name: "اصفهان",
      },
      {
        id: 142,
        name: "فلاورجان",
      },
      {
        id: 137,
        name: "شاهین شهر",
      },
      {
        id: 340,
        name: "خمینی شهر",
      },
      {
        id: 139,
        name: "کاشان",
      },
      {
        id: 10,
        name: "نجف آباد",
      },
    ],
  },
  {
    id: 8,
    data: [
      {
        id: 32,
        name: "کرج",
      },
    ],
  },
  {
    id: 23,
    data: [
      {
        id: 107,
        name: "مشهد",
      },
      {
        id: 255,
        name: "چناران",
      },
      {
        id: 306,
        name: "نيشابور",
      },
      {
        id: 291,
        name: "قوچان",
      },
      {
        id: 279,
        name: "سبزوار",
      },
      {
        id: 294,
        name: "کاشمر",
      },
    ],
  },
];

export const get_cities = (province_id) => {
  const seletedProvince = city_data.find((item) => item.id === province_id);
  return new Promise((resolve) => {
    resolve({
      data: seletedProvince.data,
      status: 200,
      success: true,
      message: "",
    });
  });
};
